import Swiper from 'swiper';

const setupInsightSwiper = function () {
  if ($('.swiper-container').length) {
    // Swiper on top
    let insightSwiper = new Swiper('.swiper-container.insight', {
      speed: 400,
      spaceBetween: 0,
      slidesPerView: 2,
      loop: true,
      init: true,
      watchSlidesVisibility: true,
      autoplay: {
        delay: 3000,
      },
      lazy: {
        loadPrevNext: true,
      },
      breakpoints: {
        576: {
          slidesPerView: 1,
        },
      },
    });

    insightSwiper.update();
  }
};

export default setupInsightSwiper;



// WEBPACK FOOTER //
// ./scripts/util/setupInsightSwiper.js